export default {

  //labs
  getLabs(data = {}) {
    if(data.hasOwnProperty('search')) {
      return env.API.get('/user/soilLabs?search='+data.search);
    }else {
      return env.API.get('/user/soilLabs');
    }
  },
  getLabsMedia() {
    return env.API.get('/user/mediaLabs');
  },
  getLab(id) {
    return env.API.get('/user/soilLabs/' + id);
  },
  update(id, data) {
    return env.API.put('/user/soilLabs/' + id, data);
  },
  create(data) {
    return env.API.post('/user/soilLabs', data);
  },
  delete(id) {
    return env.API.delete('/user/soilLabs/' + id);
  },


  //labs ext
  getAllExt() {
    return env.API.get('user/soilLabsExt');
  },
  getAllExtByLab(lab) {
    console.log(lab)
    return env.API.get('/soil-lab/ext/lab/' + lab);
  },
  getAllExtByLabMedia(lab) {
    console.log(lab)
    return env.API.get('/media-lab/ext/lab/' + lab);
  },
  getExtbyId(id) {
    return env.API.get('user/soilLabsExt/' + id);
  },
  createExt(data) {
    return env.API.post('user/soilLabsExt', data);
  },
  deleteExt(id) {
    return env.API.delete('user/soilLabsExt/' + id);
  },
  updateExt(id,data) {
    return env.API.put('user/soilLabsExt/' + id, data);
  },



}
